const IMAGE_EXTENSIONS = new Set(["jpg", "jpeg", "png", "webp", "gif", "bmp"]);

export function credentialDocumentFormat(fileName: string): string {
  const extension = fileName.split(".").at(-1)?.toLowerCase() ?? "";
  return fileName.includes(".") ? extension : "";
}

/** Excludes active document formats such as SVG. */
export function isCredentialDocumentImage(fileName: string): boolean {
  return IMAGE_EXTENSIONS.has(credentialDocumentFormat(fileName));
}
